import { render } from "./ContactPerson.vue?vue&type=template&id=29c0f3d6&scoped=true"
import script from "./ContactPerson.vue?vue&type=script&lang=js"
export * from "./ContactPerson.vue?vue&type=script&lang=js"

import "./ContactPerson.vue?vue&type=style&index=0&id=29c0f3d6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c0f3d6"]])

export default __exports__